import { useParams, createSearchParams } from 'react-router-dom'
import EnhancedNavTabs from '@common/components/Tab/EnhancedNavTabs'
import { useCombinedPermissions } from '@auth/hooks/useCombinedPermissions'
import { createSubjectTabItems } from '../components/SubjectDetails/tabs'
import { Divider } from '@mui/material'
import { useSearchParams } from 'react-router-dom'

export default function SubjectDetailsTabs() {
  const { studyId, subjectId } = useParams<{
    studyId: string
    subjectId: string
  }>()

  const [searchParams] = useSearchParams()
  const paginationDetails = {
    limit: searchParams.get('limit')!,
    prev_cursor: searchParams.get('previous_cursor')!,
    next_cursor: searchParams.get('next_cursor')!,
  }
  const { hasAnyPermission } = useCombinedPermissions()

  const subjectTabItems = createSubjectTabItems(studyId!, subjectId!, createSearchParams(paginationDetails!))

  const filteredTabRoutes = subjectTabItems
    .filter((item) => !item.permissions || hasAnyPermission(item.permissions))
    .map((item) => item.route)

  return (
    <>
      <EnhancedNavTabs routes={filteredTabRoutes} />
      <Divider />
    </>
  )
}
